import { useEffect, useState } from 'react';

import { getNotifications } from '@n2-common/services/sanityService';
import { type CmsNotification as CmsNotificationType, CmsNotificationLink } from '@n2-common/services/sanityService/cmsNotification';
import { HeadlineStyledSpan, Hero, Paragraph } from '@n2-common/ui';
import style from './style.module.scss';
import { getUtmlValues } from '@n2-common/lib/utm';

interface LinkData {
    key: string;
    value: string;
}

const externalLink = (link: CmsNotificationLink, linkData?: LinkData[]) => {
    let finalLink = link.url.externalLink || '';
    if (linkData) {
        linkData.forEach((elm) => {
            finalLink = finalLink?.replaceAll(`{${elm.key}}`, elm.value)
        });
    }
    return <a className={style.externalLink} href={`${finalLink}`}>{link.text}</a> ;
}

export const CmsFragementWithUtmVariants = ({ cmsKeyBase, linkData }: { cmsKeyBase: string; linkData: LinkData[] }) => {
    const utmValues = getUtmlValues(window);
    const cmsKeyWithUtmSource = utmValues.source ? `${cmsKeyBase}_${utmValues.source?.toLowerCase()}` : null;
    const cmsKeyWithUtmSourceAndMedium = utmValues.medium ? `${cmsKeyWithUtmSource}_${utmValues.medium?.toLowerCase()}` : null;
    const cmsKeyWithUtmSourceAndMediumAndCampaign = utmValues.campaign
        ? `${cmsKeyWithUtmSourceAndMedium}_${utmValues.campaign?.toLowerCase()}`
        : null;

    return (
        <>
            <CmsNotification cmsKey={cmsKeyBase} linkData={linkData} />
            {cmsKeyWithUtmSource && <CmsNotification cmsKey={cmsKeyWithUtmSource} linkData={linkData} />}
            {cmsKeyWithUtmSourceAndMedium && <CmsNotification cmsKey={cmsKeyWithUtmSourceAndMedium} linkData={linkData} />}
            {cmsKeyWithUtmSourceAndMediumAndCampaign && <CmsNotification cmsKey={cmsKeyWithUtmSourceAndMediumAndCampaign} linkData={linkData} />}
        </>
    );
};


const CmsNotification = ({ cmsKey, className, linkData }: { cmsKey: string; className?: string, linkData?: LinkData[] }): JSX.Element => {
    const notifications = useCmsNotification(cmsKey);

    if (notifications.length === 0) {
        return <></>;
    }
    return (
        <>
            {notifications.map((elm, i) => {
                return (
                    <Hero ui="secondary" key={i} className={className}>
                        <HeadlineStyledSpan level={3}>{elm.title}</HeadlineStyledSpan>
                        <Paragraph>{elm.description}</Paragraph>
                        {elm.link && elm.showLink && elm.link.url.externalLink ? 
                            externalLink(elm.link, linkData)
                            : null}
                    </Hero>
                );
            })}
        </>
    );
};

export function useCmsNotification(cmsKey: string) {
    const [notifications, setNotifications] = useState<CmsNotificationType[]>([]);

    useEffect(() => {
        if (!cmsKey) {
            return;
        }
        const controller = new AbortController();
        getNotifications(cmsKey, controller.signal).then((res) => {
            setNotifications(res);
        });
        return () => controller.abort();
    }, [cmsKey]);
    return notifications;
}

export default CmsNotification;
